/**
 * This custom hook provides the functionality to save a user with the given parameters.
 */

import {useContext, useState} from "react";
import {useHistory} from "react-router-dom";
import {useSnackbar} from "notistack";
import {FirebaseAuthContext} from "../../../../commons/firebase/FirebaseAuthProvider";
import {useIntl} from "react-intl";

const useNewScoredVideo = (associatedVideo) => {
    const {signedInUser} = useContext(FirebaseAuthContext);
    const {enqueueSnackbar} = useSnackbar();

    const history = useHistory();

    const [saveInProgress, setSaveInProgress] = useState(false)

    // Internationalization for simple strings
    const intl = useIntl();

    const save = async (sceneData) => {
        setSaveInProgress(true)
        const idToken = await signedInUser.getIdToken()

        return fetch('/reg-main/videos/' + associatedVideo.key + '/scoredScenes', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({
                idToken: idToken,
                sceneData: {
                    basics: {
                        sceneStart: sceneData.videoRange[0],
                        sceneEnd: sceneData.videoRange[1],
                        difficulty: sceneData.difficulty,
                        mainFocus: sceneData.mainFocus,
                        trailingPeriod: sceneData.trailingPeriod,
                        athleteLeftPosition: sceneData.athleteLeftPosition,
                        blurring: sceneData.blurring
                    },
                    scoreDefinitions: sceneData.scoreDefinitions
                }
            })
        }).then(async (data) => {
            // Throw an error including the textual status of the HTTP response code (no detailed message necessary)
            if (data.status !== 200) {
                throw new Error((await data.json()).status)
            }

            enqueueSnackbar(
                intl.formatMessage({
                    id: 'app.scoredScene.messages.new.success',
                    defaultMessage: 'Video scene created.'
                }), {
                    variant: 'success',
                    preventDuplicate: true,
                    autoHideDuration: 3000
                });
            history.push({
                pathname: '/admin/videos/' + associatedVideo.key + '/edit',
                selectedVideo: associatedVideo
            })
        }).catch((error) => {
            enqueueSnackbar(
                intl.formatMessage({
                    id: 'app.scoredScene.messages.new.error',
                    defaultMessage: 'Something went wrong while creating the video scene: {error}'
                }, {error: error.message}), {
                    variant: 'error',
                    preventDuplicate: true,
                    autoHideDuration: 5000
                });
        }).finally(() => {
            setSaveInProgress(false)
        })
    }

    const cancel = () => {
        history.push({
            pathname: '/admin/videos/' + associatedVideo.key + '/edit'
        })
    }

    return {save, cancel, saveInProgress}
}
export default useNewScoredVideo;